import React from "react";
import "../Styles/NotFound.css";

export default function NotFound() {
  return (
    <div className="NotFound">
      <div className="NotFound-Box">
        <p className="NotFound">Lo sentimos, no encontramos ningún Tweet.</p>
      </div>
    </div>
  );
}